import { connect } from 'react-redux';
import actions from '../redux/actions/user';
import UserLoginHistoryComponent from '../components/UserLoginHistoryComponent';

const mapStateToProps = (state) => ({
  orderTrans: state.orderTrans,
});

const mapDispatchToProps = (dispatch) => ({
  getUserLoginHistory: (params, callback) => {
    dispatch(actions.getUSerLoginHistory(params, callback));
  },
});

export const UserLoginHistoryContainer = connect(mapStateToProps, mapDispatchToProps)(UserLoginHistoryComponent);
